var chunkToChildrenMap = {
	"154": [
		774,
		827,
		8
	],
	"313": [
		774,
		827,
		8
	],
	"568": [
		774,
		827,
		8
	],
	"919": [
		774,
		827,
		8
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, function() {

}); };